import React, {memo, useCallback, useEffect, useState} from 'react';
import {DataSources} from "../../services/api/DataSources";
import {apiErrorRaised, useApiErrorDispatch} from "../../context/api_error/ApiErrorIndex";
import {useProjectState} from "../../context/project/ProjectIndex";
import {createDataSourceColumnRenderers} from './Columns';

const DataSourceItem = ({feedData, visibleColumns = ['name', 'url', 'actions', 'status']}) => {
  const projectState = useProjectState();
  const apiErrorDispatch = useApiErrorDispatch();
  const [feed, setFeed] = useState(feedData);

  // Memoized column renderers
  const COLUMN_RENDERERS = React.useMemo(() => createDataSourceColumnRenderers(), []);

  useEffect(() => {
    setFeed(feedData);
  }, [feedData]);

  const handleToggle = useCallback((e) => {
    const {name, checked} = e.target;
    const action = checked ? DataSources.activate : DataSources.disable;

    action(projectState.companyId, projectState.projectId, feed.id)
      .then((r) => {
        if (r?.status < 400) {
          setFeed(prevFeed => ({...prevFeed, [name]: checked}));
        } else {
          apiErrorRaised(apiErrorDispatch, r?.response);
        }
      });
  }, [projectState.companyId, projectState.projectId, feed.id, apiErrorDispatch]);

  const getColumnProps = useCallback((columnId) => {
    const baseProps = {feed, projectState};

    // Add column-specific props
    switch (columnId) {
      case 'status':
        return {
          ...baseProps,
          handleToggle
        };
      default:
        return baseProps;
    }
  }, [feed, projectState, handleToggle]);

  return (
    <tr>
      {visibleColumns.map(columnId => {
        const renderColumn = COLUMN_RENDERERS[columnId];
        if (!renderColumn) return null;

        const props = getColumnProps(columnId);
        return (
          <React.Fragment key={columnId}>
            {renderColumn(props)}
          </React.Fragment>
        );
      })}
    </tr>
  );
};

export default memo(DataSourceItem);
